module.exports = __webpack_public_path__ + "static/img/Adelaide-Crows.d721c38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adelaide-Crows.jpg
// module id = b4gq
// module chunks = 1